export const SS_UPGRADE_EVENT = {
  upgradeNowClicked: "upgrade_now_clicked",
  upgradeIntroViewed: "upgrade_intro_viewed",
  upgradeIntroConfirmed: "upgrade_intro_confirmed",
  complianceGateEvaluated: "compliance_gate_evaluated",
  complianceGateBlockedShown: "compliance_gate_blocked_shown",
  kycPageViewed: "kyc_page_viewed",
  kycMethodSelected: "kyc_method_selected",
  kycQrCodeShown: "kyc_qr_code_scanned",
  kycEmailLinkSent: "kyc_email_link_sent",
  kycVerificationStarted: "kyc_verification_started",
  kycVerificationCompleted: "kyc_verification_completed",
  verificationCompleteViewed: "verification_complete_viewed",
  explorePlansClicked: "explore_plans_clicked",
  upgradeFlowAbandoned: "upgrade_flow_abandoned",
  errorShown: "error_shown"
} as const

export type UpgradeSource =
  | "top_hat_bar"
  | "livechat_widget"
  | "numbers_banner"
  | "trial_expired_page"
  | "trial_balance_depleted"
  | "email_last_day"
  | "email_day_after"

export type KycMethod = "desktop" | "mobile_qr" | "email_link"

export type UpgradeStep = "upgrade_intro" | "compliance_gate" | "kyc_page" | "kyc_verification"
